import PropTypes from "prop-types";
import styles from "./ContractSuccess.module.css";
import Lottie from "lottie-react";
import approved from "./Animation - Generated Request GIF.json";
import { useNavigate, useParams } from "react-router-dom";

const ContractSuccess = ({ msg }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <div className={`${styles.pageContainer} d-flex justify-content-center align-items-center h-100`}>
      <div className={styles.httpslottiefilescomanimatParent}>
        <Lottie className={styles.httpslottiefilescomanimatIcon} animationData={approved} loop={true} />
        <div className={styles.successfullyGeneratedRequest}>Successfully Sent</div>
        {msg === "contract_created" && (
          <button
            className={styles.returnToKycList}
            onClick={() => {
              navigate(`/content/contract/main`);
            }}
          >
            <b className={styles.returnToKyc}>Return to Contract List</b>
          </button>
        )}
      </div>
    </div>
  );
};

ContractSuccess.propTypes = {
  className: PropTypes.string,
};

export default ContractSuccess;

// ApprovedPOPup
